import React from 'react';
import * as RadixContextMenu from '@radix-ui/react-context-menu';

import { bemBlock } from '../../modules/bem';
import { ScrollArea } from '../scroll-area/ScrollArea';

import './ContextMenuContent.less';

const block = bemBlock('n-context-menu-content');

type ContentOwnProps = {
  header?: React.ReactNode;
  footer?: React.ReactNode;
};

type ContentProps = React.ComponentPropsWithoutRef<typeof RadixContextMenu.Content> &
  ContentOwnProps;

export const ContextMenuContent = React.forwardRef<
  React.ElementRef<typeof RadixContextMenu.Content>,
  ContentProps
>(function ContextMenuContent({ className, children, header, footer, ...props }, ref) {
  return (
    <RadixContextMenu.Content
      ref={ref}
      className={block({
        extra: className,
      })}
      {...props}
    >
      {header && (
        <>
          <div className={block('header')}>{header}</div>
          <RadixContextMenu.Separator />
        </>
      )}
      <ScrollArea className={block('scroll-area')}>
        <ScrollArea.Viewport className={block('scroll-area-viewport')}>
          {children}
        </ScrollArea.Viewport>
        <ScrollArea.Scrollbar orientation="vertical" />
        <ScrollArea.Scrollbar orientation="horizontal" />
        <ScrollArea.Corner />
      </ScrollArea>
      {footer && (
        <>
          <RadixContextMenu.Separator />
          {footer}
        </>
      )}
    </RadixContextMenu.Content>
  );
});
